/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  FairMarketValueConfigurationService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostFairMarketValueConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        FairMarketValueConfigurationService.postApiAwardApiAppFairMarketValueConfigurationUpdateFairMarketValueConfiguration(
          payload
        )
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getCustomerTitleListWithPagination');
          toast.success(
            <ToastComponent label='Success' message={`Fair Market Value Configuration added.`} />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostFairMarketValueConfig;
